export function replaceAll(str = '', mapWith: Record<string, string> = {}) {
  const keys = new RegExp(Object.keys(mapWith).join('|'), 'gi');

  return str.replace(keys, (matched) => mapWith[matched]!);
}
